import React from "react";
import { IEbookId } from "../../Ebook.props";
import EditEbook from "./EditEbook";

const EditEbookIndex: React.FC<IEbookId> = ({ ebookId,setSelectedEbookId }) => {
  return <EditEbook ebookId={ebookId} setSelectedEbookId={setSelectedEbookId} />;
};

export default EditEbookIndex;
